<template>
  <div  >
    <Header
      :leftArrow="true"
      :leftText="''"
      @leftClick="onClickLeft"
      @onRefreshClick="onRefresh"
      @rightAdd="toAddRoom"
      :rightIcons="true"
      :right-add="true"
    >
    </Header>
    <div class="home room watch_movie">
      <div class="home_notice-search">
        <form>
          <input type="search" name="search" placeholder="ルームを検索" v-model="searchValue">
          <input type="submit" name="submit" value="検索" onclick="return false;" >
        </form>
      </div>
      <div class="watch_wrap">
        <div class="room-list">
          <div class="movie-item room-item" v-for="item in roomList" :key="item" v-show="item.name.includes(searchValue)">
            <p class="room-item_name">{{ item.name }}</p>
            <button class="movie-remove-btn room-remove-btn" @click.stop >
              <img src="@/assets/img/home/icon_remove.png" alt="" @click="openDialog(item)" >
            </button>
            <div class="room-select-pop" :class="[item.status == 'open' ? 'open':'']">
              <a @click="editRoom(item)" class="movie-edit-pop">編集</a>
              <a @click="openDeleteDialog(item)" class="movie-remove-pop">削除</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="movie-remove_modal" :class="[this.deleteDiaLogShow ? 'active' : '']">
    <div class="movie-remove_modal_inner">
      <p class="watch-end_modal_title">このルームを削除しますか？</p>
      <div class="movie-remove_btn">
        <a @click="closeDeleteDialog" class="btn-cancel">キャンセル</a>
        <a @click="deleteRoom" class="btn-end">削除する</a>
      </div>
    </div>
  </div>
</template>

<script>
  import {DeleteRoom, GetRoomListByCreated} from "@/services/room";
  import Header from "@/components/Header.vue";
  import { Toast} from "vant";
  import "vant/es/toast/style";

  export default {
    data() {
      return {
        active: 0,
        screenWidth: null,
        roomList: [],
        userInfo: {},
        timeout:null,
        chooseCallFlg:false,
        chooseItem:null,
        actions :[
          { name: 'ビデオ通話' ,type:'video'},
          { name: '音声通話' ,type:'audio'},
        ],
        deleteDiaLogShow:false,
        selectItem:null,
        searchValue:"",
      };
    },
    components: {
      Header,
    },
    mounted() {
      this.userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
      this.screenWidth = document.body.clientWidth;
      window.onresize = () => {
        return (() => {
          this.screenWidth = document.body.clientWidth;
        })();
      };
      this.initRoomList();
      document.addEventListener('click', this.closeDiaLog)
    },
    beforeUnmount() {
      document.removeEventListener('click', this.closeDiaLog)
    },
    methods: {
      openDeleteDialog(item){
        this.deleteDiaLogShow = true;
        this.selectItem = item;
      },
      closeDeleteDialog(){
        this.deleteDiaLogShow = false;
        this.selectItem = null;
      },
      closeDiaLog(){
        this.roomList.forEach(item=>{
          item.status = 'close';
        });
      },
      openDialog(item){
        this.closeDiaLog();
        item.status = 'open';
      },
      toAddRoom(){
        this.$router.push({
          path: "/roomAdd",
        });
      },
      editRoom(item){
        this.$router.push({
          path: "/roomEdit",
          query: { id:item.id, room_id: item.room_id},
        });
      },
      deleteRoom() {
        if(this.selectItem){
          DeleteRoom({ ids: [this.selectItem.id] }).then((result) => {
            if (result.data.code >= 0) {
              Toast("削除に成功しました。");
            } else {
              Toast("削除に失敗しました。");
            }
            this.closeDeleteDialog();
            this.initRoomList();
          });
        }
      },
      initRoomList() {
        GetRoomListByCreated().then((res) => {
            this.roomList = res.data.data || [];
        });
      },
      onClickLeft() {
        history.back();
      },
      onRefresh() {
        Toast.loading({
          message: "",
          forbidClick: true,
          duration: 1000,
        });
        this.initDoctorList();
      },
    },
    watch: {
      screenWidth: function (n, o) {},
    },
  };
</script>

<style scoped>
     
     
    
</style>
